<template>
  <div class="list-bg" ref="myElement">
    <div class="title-name">我的下载</div>
    <table class="resources">
      <tr>
        <th>资源名称</th>
        <th>资源类型</th>
        <th>下载日期</th>
        <th>操作</th>
      </tr>
      <tr
        v-for="item in userDownloads"
        :title="item.softName"
        :key="item.softId"
      >
        <td>
          <i :class="['iconfont', iconClassName(item)]"></i>
          <div
            class="title"
            :title="item.softName"
            data-io-click="tracker"  @click="handleOpenPreview(1, item.softId, item)"
          >
            {{ item.softName }}
          </div>
        </td>
        <td>
          <span class="item">{{ item.softType }}</span>
        </td>
        <td>
          <span class="item">{{
            item.date.replace(/\s[\x00-\xff]*/g, "")
          }}</span>
        </td>
        <td>
          <button class="btn" data-io-click="tracker"  @click="handleDownload(item.softId)">
            重新下载
          </button>
        </td>
      </tr>
    </table>
    <p class="loading" v-if="isLoadingCollections">正在加载中~</p>
    <empty-list
      v-if="!userDownloads.length && !isLoadingCollections"
      text="没有更多了~"
    ></empty-list>
    <!-- <p class="empty" v-if="!userDownloads.length">没有更多了~</p> -->
    <div class="pages" v-if="totalCount >= pageSize">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="pageIndexChange"
        :current-page="pageIndex"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="totalPages"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import softUtil from "@/assets/js/service/softUtil";
import EmptyList from "@/components/EmptyList.vue";
import { getUserDownload } from "@/utils/apis";
export default {
  data() {
    return {
      // 是否还有下载列表
      hasMoreDownloads: true,
      // 是否正在加载下载列表
      isLoadingCollections: false,
      // 用户下载列表
      userDownloads: [],
      // 下载资料当前页
      collectionPageIndex: 1,
      // 当前页码
      pageIndex: 1,
      // 每页显示条数
      pageSize: 20,
      // 资料总数
      totalCount: 0,
      // 总页数
      totalPages: 0,
      // 分页条数列表
      pageSizes: [20, 30, 50],
    };
  },
  components: {
    EmptyList,
  },
  mounted() {
    this.loadDownloadList();
    this.initXepSdk();
  },
  methods: {
    initXepSdk() {
      window.XEP.init({
        window: {
          id: "wxt",
          left: 0, // 网校通左侧导航宽度，下载收藏页面没有，传0即可
          top: 0, // 网校通顶部导航高度，下载收藏页面没有，传0即可
        },
        message: {
          onReceive: this.receiveMsg,
          // 根据需要绑定消息接收事件
        },
      });
    },
    iconClassName(item) {
      // 1）ppt图标：.pptx、.ppt
      // 2）word图标：.doc、.docx；
      // 3）pdf图标：.pdf
      // 4）压缩包图标：.zip、.rar
      // 5）视频图标：.mp4、.avi、.wmv、.rm、.rmvb
      // 6）音频图标：.mp3、wma、wav
      // 7）图片图标：.png、.jpg、.jpeg、.GIF、
      // 8）其他图标：非以上的其它文件格式
      let supportClassName = [
        "pptx",
        "ppt",
        "doc",
        "docx",
        "pdf",
        "zip",
        "rar",
        "mp4",
        "avi",
        "wmv",
        "rm",
        "rmvb",
        "mp3",
        "wma",
        "wav",
        "png",
        "jpg",
        "jpeg",
        "gif",
        "compress",
      ];
      let fileExt = item.fileExt || item.extension;
      // console.log("fileExt", fileExt);
      let typeId = item.typeId || String(item.resourceType);
      // console.log("typeId", typeId);
      if (typeId && typeId.startsWith("3106") && typeId.length >= 4) {
        if (typeId === "310603" || typeId === "310601") {
          return "icon-doc-animation";
        }
      }
      if (fileExt && supportClassName.includes(fileExt.toLowerCase())) {
        return "icon-doc-" + item.fileType;
      } else {
        return "icon-doc-others";
      }
    },
    // 获取用户下载列表
    async loadDownloadList() {
      // console.log("下载列表");
      // let currentCourse = await this.loadCurrentCourse();
      //  let currentCourse = Cookie.get(CURRENTCOURSE) || null;
      //   currentCourse = currentCourse ? JSON.parse(currentCourse) : null;
      // 是否有还有下载列表
      if (this.hasMoreDownloads && !this.isLoadingDownloads) {
        // 加载状态开始
        this.isLoadingDownloads = true;
        const data = await getUserDownload({
          page: this.pageIndex,
          pageSize: 30,
          // courseId: currentCourse.courseId,
        });
        // console.log("dataDown", data);
        // if (data.code === 200) {
        //   const resultList = data.result.list;
        //   if (resultList && resultList.length !== 0) {
        //     this.userDownloads = resultList;
        //     // this.userDownloads = this.userDownloads.concat(result);
        //     // 页码加1
        //     // this.downloadPageIndex++;
        //   } else {
        //     // 没有下载列表了
        //     this.hasMoreDownloads = false;
        //   }
        // }
        if (data.code === 200) {
          // const result = data.result.list;
          let { list: result, totalPages } = data.result;
          this.hasMoreDownloads = this.downloadPageIndex != totalPages;
          // 如果是第一页，用户收藏列表需要重置
          if (this.pageIndex === 1) {
            this.userDownloads = result || [];
            console.log("this.userDownloads", this.userDownloads);
            this.$nextTick(() => {
              const dom = this.$refs.myElement;
              const domSize = {
                width: dom.offsetWidth,
                height: this.$el.clientHeight,
              };
              if (Object.keys(this.userDownloads).length == 0) {
                domSize.height = 575;
              }
              XEP.window.documentChanged(domSize);
            });
          } else {
            this.userDownloads = this.userDownloads.concat(result);
          }
          // 页码加1
          this.downloadPageIndex++;
        }
        // 加载状态停止
        this.isLoadingDownloads = false;
      }
    },
    // 下载
    async handleDownload(id) {
      softUtil.WriteDownScript(id, this);
    },
    pageSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageIndex = 1;
      this.pageSize = val;
      this.loadCollections();
    },
    pageIndexChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.loadCollections();
    },
    // 资料跳转
    handleOpenPreview(type, softId, item) {
      let typeId = item && (item.typeId || String(item.resourceType));
      let isMaterialPreview =
        typeId && typeId.startsWith("3106") && typeId.length > 4;
      type = isMaterialPreview ? 6 : type;
      // ${
      //     type == 5 ? "?courseId=" + this.currentCourse.courseId : ""
      //   }
      window.open(
        `/soft/${softId}-${type}.html${
          this.$route.query.xep_flag === "1" ? "?xep_flag=1" : ""
        }`
      );
    },
  },
};
</script>
<style scoped lang="scss">
.list-bg {
  width: calc(100% - 296px);
  background: #fff;
  min-height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 24px;
  &:after {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    background: -webkit-linear-gradient(left, #97edfc 0%, #efdffb 100%)
      no-repeat;
    background: linear-gradient(90deg, #97edfc 0%, #efdffb 100%) no-repeat;
    background-size: 100% 86px;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0.6;
  }
  .title-name {
    font-size: 18px;
    color: #333;
    position: relative;
    z-index: 2;
    line-height: 1;
    padding: 16px 0 20px 0px;
  }
}
.resources {
  width: 100%;
  // margin-left: 40px;
  position: relative;
  z-index: 2;
  tr {
    position: relative;
    z-index: 1;
    &:before {
      position: absolute;
      left: 0;
      bottom: -1px;
      right: 0;
      height: 1px;
      background: #e6e7e9;
      content: "";
    }
    th {
      color: #80848b;
    }
    td,
    th {
      // width: calc((100% - 80px) / 4);
      width: 100px;
      padding: 20px 0;
      font-size: 14px;
      text-align: left;
      &:first-child {
        // width: 55%;
        width: calc(100% - 100px);
        padding-right: 20px;
      }
      .item {
        font-size: 14px;
        color: #80848b;
      }
    }
    .iconfont {
      width: 18px;
      height: 18px;
      border: 1px solid #eff1f4;
      border-radius: 2px;
      font-size: 14px;
      text-align: center;
      display: inline-block;
      vertical-align: middle;
    }
    .title {
      // width: calc(100% - 25px);
      width: 572px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      color: #333;
      line-height: 1;
      cursor: pointer;
      margin-left: 5px;
      display: inline-block;
      vertical-align: middle;
      &:hover {
        color: #0057ff;
      }
    }
    .btn {
      text-align: center;
      font-size: 14px;
      color: #0057ff;
      cursor: pointer;
      &:hover {
        color: #669aff;
      }
    }
  }
}
.pages {
  position: relative;
  z-index: 10;
  text-align: right;
  padding: 34px 24px 34px 0;
}
</style>
